import { useTheme } from '../context/ThemeContext';
import { useScrollAnimation } from '../../../hooks/useScrollAnimation';

export default function LocalFocus() {
  const { theme } = useTheme();
  const { ref, isVisible } = useScrollAnimation();

  return (
    <section
      ref={ref}
      className="relative py-14 sm:py-24 md:py-32 px-4 overflow-hidden"
      style={{ background: 'linear-gradient(135deg, #0f0f0f 0%, #1a1a1a 50%, #111 100%)' }}
    >
      {/* Dezentes Muster im Hintergrund */}
      <div
        className="absolute inset-0 opacity-5"
        style={{
          backgroundImage: `radial-gradient(circle at 1px 1px, ${theme.colors.accent} 1px, transparent 0)`,
          backgroundSize: '40px 40px',
        }}
      />

      {/* Akzent-Glow */}
      <div
        className="absolute top-0 left-1/2 -translate-x-1/2 w-[600px] h-[300px] rounded-full opacity-10 blur-3xl pointer-events-none"
        style={{ background: `radial-gradient(ellipse, ${theme.colors.accent} 0%, transparent 70%)` }}
      />

      {/* Content */}
      <div className="relative max-w-4xl mx-auto">
        {/* Headline */}
        <h2
          className="text-3xl sm:text-4xl md:text-6xl font-black text-white mb-5 sm:mb-6 leading-tight sm:text-center"
          style={{
            fontFamily: theme.fonts.heading,
            opacity: isVisible ? 1 : 0,
            transform: isVisible ? 'translateY(0)' : 'translateY(40px)',
            transition: 'opacity 0.8s ease 0.1s, transform 0.8s ease 0.1s',
          }}
        >
          Für Betriebe, die im Würmtal<br />nicht untergehen wollen.
        </h2>

        {/* Copy */}
        <div
          className="max-w-2xl sm:mx-auto space-y-4 sm:text-center"
          style={{
            opacity: isVisible ? 1 : 0,
            transform: isVisible ? 'translateY(0)' : 'translateY(40px)',
            transition: 'opacity 0.8s ease 0.3s, transform 0.8s ease 0.3s',
          }}
        >
          <p className="text-base sm:text-lg md:text-xl text-white/90 font-medium leading-relaxed">
            Ihre Konkurrenz ist online präsent. Ihre Kunden suchen online.
          </p>
          <p className="text-sm sm:text-base md:text-lg text-white/60 leading-relaxed">
            Wer im Würmtal gefunden werden will, braucht mehr als eine Visitenkarte im Netz.<br />
            Sie brauchen einen Auftritt, der Eindruck macht.
          </p>
        </div>

        {/* Stats */}
        <div
          className="flex flex-col md:flex-row items-center justify-center gap-0 mt-10 sm:mt-16 max-w-3xl mx-auto divide-y md:divide-y-0 md:divide-x divide-white/10"
          style={{
            opacity: isVisible ? 1 : 0,
            transform: isVisible ? 'translateY(0)' : 'translateY(40px)',
            transition: 'opacity 0.8s ease 0.5s, transform 0.8s ease 0.5s',
          }}
        >
          {[
            { value: '85%', label: 'suchen online vor dem Anruf' },
            { value: '3 Sek.', label: 'entscheiden über Vertrauen' },
            { value: 'Lokal', label: 'im Würmtal verwurzelt' },
          ].map((stat, i) => (
            <div key={i} className="flex-1 px-4 sm:px-8 lg:px-10 py-6 md:py-0 text-center">
              <div
                className="text-5xl sm:text-6xl md:text-7xl font-black leading-none mb-3"
                style={{
                  background: `linear-gradient(135deg, #fff 0%, ${theme.colors.secondary} 50%, ${theme.colors.accent} 100%)`,
                  WebkitBackgroundClip: 'text',
                  WebkitTextFillColor: 'transparent',
                  backgroundClip: 'text',
                  fontFamily: theme.fonts.heading,
                }}
              >
                {stat.value}
              </div>
              <div className="text-xs sm:text-sm text-white/55 font-medium tracking-wide uppercase">{stat.label}</div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
